import trackingMiddleWare from 'client/contexts/Tracking/middleware'
import localStorageMiddleware from 'client/contexts/Purchase/middleware'
import loginMiddleware from 'client/contexts/Login/middleware'

const rootMiddleware = [trackingMiddleWare, localStorageMiddleware, loginMiddleware]

export default rootMiddleware
